import { render, staticRenderFns } from "./dataListJggd.vue?vue&type=template&id=11b7ee43&scoped=true"
import script from "./dataListJggd.vue?vue&type=script&lang=js"
export * from "./dataListJggd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b7ee43",
  null
  
)

export default component.exports